import { Option } from 'fp-ts/Option';
import { Fragment } from 'react';

import { DataTestId, TextKey } from '@mews-distributor/common';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework/localization';
import { Checkbox } from '@optimus-web/core';

import { TermsLink } from './TermsLink';

const id = 'terms-and-conditions-checkbox';

interface Link {
    markdown: Option<string>;
    name: string;
    textKey: Mews.TextKey;
    url: Option<string>;
}

interface TermsAndConditionsProps {
    checked: boolean;
    onChange: (event: React.SyntheticEvent<HTMLElement>, checked: boolean) => void;
    error?: React.ReactNode;
    links: Link[];
}

const andSeparator = (
    <>
        {UnicodeEntity.NoBreakSpace}
        <LocalizedText textKey={TextKey.AndAcknowledge} />
        {UnicodeEntity.NoBreakSpace}
    </>
);

const commaSeparator = `${UnicodeEntity.Comma}${UnicodeEntity.NoBreakSpace}`;

export const TermsAndConditions = ({ checked, onChange, error, links }: TermsAndConditionsProps) => (
    <>
        <Checkbox
            checked={checked}
            onChange={onChange}
            data-test-id={DataTestId.TermsAndConditionsCheckbox}
            id={id}
            error={error}
            required
            name={id}
        >
            <LocalizedText textKey={TextKey.AgreeTo} />
            {UnicodeEntity.NoBreakSpace}
            {links.map(({ markdown, name, textKey, url }, index) => (
                <Fragment key={name}>
                    {index === links.length - 1 ? andSeparator : null}
                    <TermsLink markdown={markdown} textKey={textKey} url={url} />
                    {index < links.length - 2 ? commaSeparator : null}
                </Fragment>
            ))}
            {UnicodeEntity.FullStop}
        </Checkbox>
    </>
);
